import { defineMessages } from 'react-intl'

export default defineMessages({
  title: {
    id: 'components.NewOrderModal.title',
    defaultMessage: 'Select customer and contact for order',
  },
  customerSelectLabel: {
    id: 'components.NewOrderModal.customerLabel',
    defaultMessage: 'Customer',
  },
  customerSelectDescription: {
    id: 'components.NewOrderModal.customerSelectDescription',
    defaultMessage: 'Select the customer to which the order belongs',
  },
  customerSelectPlaceholder: {
    id: 'components.NewOrderModal.customerSelectPlaceholder',
    defaultMessage: 'Customer name',
  },
  contactSelectLabel: {
    id: 'components.NewOrderModal.contactLabel',
    defaultMessage: 'Contact',
  },
  contactSelectDescription: {
    id: 'components.NewOrderModal.contactSelectDescription',
    defaultMessage: "Select the primary contact of the order.",
  },
  contactSelectPlaceholder: {
    id: 'components.NewOrderModal.contactSelectPlaceholder',
    defaultMessage: 'Contact name',
  },
  createOrder: {
    id: 'components.NewOrderModal.createOrder',
    defaultMessage: 'Create order',
  },
  createLoading: {
    id: 'components.NewOrderModal.createLoading',
    defaultMessage: 'Creating...',
  },
  duplicateOrder: {
    id: 'components.NewOrderModal.duplicateOrder',
    defaultMessage: 'Duplicate order',
  },
  duplicateLoading: {
    id: 'components.NewOrderModal.duplicateLoading',
    defaultMessage: 'Duplicating...',
  }
})
